export const ARTICLE_CONTENT_COL_CLASSES = 'col-lg-9 col-xl-7 offset-xl-1';

export const ARTICLE_TYPES = {
  PODCAST: 'podcast',
  WEBINAR: 'webinar'
};

export const ARTICLE_TYPE_TITLES = {
  [ARTICLE_TYPES.PODCAST]: 'Podcast',
  [ARTICLE_TYPES.WEBINAR]: 'Webinar'
};
